export const GENDER_SAVE = 'GENDER_SAVE';
